module.exports = "/fonts/feather.svg?e909dd1831804f969b03bf76dc952eda";